// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vOsb","name":"styles_name__2uyer","phone":"styles_phone__wFADU"};